const TOKEN_STRING = "Bearer";
const TOKEN_KEY = "access_token";
const REFRESH_TOKEN_KEY = "refresh_token";
const USER_ROLES = "user_roles";
const USER_BRANDS = "user_brands";

/**
 * Manage the how Access Tokens are being stored and retreived from storage.
 *
 * Current implementation stores to localStorage. Local Storage should always be
 * accessed through this instace.
 **/
const TokenService = {
  getToken() {
    return localStorage.getItem(TOKEN_KEY);
  },

  saveToken(accessToken) {
    localStorage.setItem(TOKEN_KEY, accessToken);
  },

  removeToken() {
    localStorage.removeItem(TOKEN_KEY);
  },

  getRefreshToken() {
    return sessionStorage.getItem(REFRESH_TOKEN_KEY);
  },

  saveRefreshToken(refreshToken) {
    sessionStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
  },

  removeRefreshToken() {
    sessionStorage.removeItem(REFRESH_TOKEN_KEY);
  },

  saveUserRoles(userRoles) {
    localStorage.setItem(USER_ROLES, userRoles);
  },

  getUserRoles() {
    return localStorage.getItem(USER_ROLES);
  },

  removeUserRoles() {
    localStorage.removeItem(USER_ROLES);
  },

  saveUserBrands(userBrands) {
    localStorage.setItem(USER_BRANDS, userBrands);
  },

  getUserBrands() {
    return localStorage.getItem(USER_BRANDS);
  },

  removeUserBrands() {
    localStorage.removeItem(USER_BRANDS);
  },
};

const PrivilegeStorageService = {
  getStoredBrand() {
    return localStorage.getItem("brand");
  },

  setStoredBrand(brand) {
    localStorage.setItem("brand", JSON.stringify(brand) || {});
  },

  removeStoredBrand() {
    localStorage.removeItem("brand");
  },

  getStoredParams() {
    return localStorage.getItem("params");
  },

  setStoredParams(params) {
    localStorage.setItem("params", JSON.stringify(params) || {});
  },

  removeStoredParams() {
    localStorage.removeItem("params");
  },
};

const CrmTriggerStorageService = {
  getStoredBrand() {
    return localStorage.getItem("crm_trigger_brand");
  },

  setStoredBrand(brand) {
    localStorage.setItem("crm_trigger_brand", JSON.stringify(brand) || {});
  },

  removeStoredBrand() {
    localStorage.removeItem("crm_trigger_brand");
  },

  getStoredTriggerType() {
    return localStorage.getItem("crm_trigger_type");
  },

  setStoredTriggerType(type) {
    localStorage.setItem("crm_trigger_type", JSON.stringify(type) || {});
  },

  removeStoredTriggerType() {
    localStorage.removeItem("crm_trigger_type");
  },

  getStoredStatus() {
    return localStorage.getItem("crm_trigger_status");
  },

  setStoredStatus(status) {
    localStorage.setItem("crm_trigger_status", JSON.stringify(status) || {});
  },

  removeStoredStatus() {
    localStorage.removeItem("crm_trigger_status");
  },

  getStoredStartDateFrom() {
    return localStorage.getItem("crm_trigger_start_from");
  },

  setStoredStartDateFrom(date) {
    localStorage.setItem("crm_trigger_start_from", JSON.stringify(date) || {});
  },

  removeStoredStartDateFrom() {
    localStorage.removeItem("crm_trigger_start_from");
  },

  getStoredStartDateTo() {
    return localStorage.getItem("crm_trigger_start_to");
  },

  setStoredStartDateTo(date) {
    localStorage.setItem("crm_trigger_start_to", JSON.stringify(date) || {});
  },

  removeStoredStartDateTo() {
    localStorage.removeItem("crm_trigger_start_to");
  },

  getStoredParams() {
    return localStorage.getItem("crm_trigger_params");
  },

  setStoredParams(params) {
    localStorage.setItem("crm_trigger_params", JSON.stringify(params) || {});
  },

  removeStoredParams() {
    localStorage.removeItem("crm_trigger_params");
  },

  getCreateTriggerType() {
    return localStorage.getItem("create_trigger_type");
  },

  setCreateTriggerType(triggerType) {
    localStorage.setItem(
      "create_trigger_type",
      JSON.stringify(triggerType) || {}
    );
  },

  removeCreateTriggerType() {
    localStorage.removeItem("create_trigger_type");
  },
};

const BookingStorageService = {
  setStoredCurrentPage(currentPage) {
    localStorage.setItem(
      "booking_current_page",
      JSON.stringify(currentPage) || {}
    );
  },

  getStoredCurrentPage() {
    return localStorage.getItem("booking_current_page");
  },

  removeStoredCurrentPage() {
    localStorage.removeItem("booking_current_page");
  },

  getStoredParams() {
    return localStorage.getItem("booking_params");
  },

  setStoredParams(params) {
    localStorage.setItem("booking_params", JSON.stringify(params) || {});
  },

  removeStoredParams() {
    localStorage.removeItem("booking_params");
  },
};

const BookingCalendarStorageService = {
  getStoredParams() {
    return localStorage.getItem("booking_calendar_params");
  },

  setStoredParams(params) {
    localStorage.setItem(
      "booking_calendar_params",
      JSON.stringify(params) || {}
    );
  },

  removeStoredParams() {
    localStorage.removeItem("booking_calendar_params");
  },
};

export {
  TokenService,
  TOKEN_STRING,
  PrivilegeStorageService,
  CrmTriggerStorageService,
  BookingStorageService,
  BookingCalendarStorageService,
};
